import {useState} from "react";
import {SearchProps} from "./types";
import {TextField} from "@mui/material";
import {FormattedMessage, defineMessages} from "react-intl";
import {useEndpointStatusExtensionLazyQuery} from "./queries.generated";

enum E164ErrorState {
    NONE_FOUND = "NONE_FOUND",
    AMBIGUOUS = "AMBIGUOUS",
}

const E164_ERROR_MESSAGES = defineMessages<E164ErrorState>({
    NONE_FOUND: {id: "endpointStatus.e164.none", defaultMessage: "E.164 not found"},
    AMBIGUOUS: {id: "endpointStatus.e164.ambiguous", defaultMessage: "Ambiguous: multiple domains matched"},
});

const SearchDomainByE164 = ({onChange, style}: SearchProps) => {
    const [value, setValue] = useState("");
    const [error, setError] = useState<E164ErrorState | null>(null);
    const [loading, setLoading] = useState(false);
    const [extensionQuery] = useEndpointStatusExtensionLazyQuery();

    const search = async () => {
        setLoading(true);

        const {data} = await extensionQuery({
            variables: {
                filter: value,
            },
            fetchPolicy: "no-cache",
        });

        const foundExtensions =
            data?.users?.items.filter((e) => e.number.e164.search(value.replace("+", "")) !== -1) ?? [];

        const domains: Record<number, string> = {};

        foundExtensions.reduce((previousValue, currentValue) => {
            previousValue[currentValue.number.domain.id] = currentValue.number.domain.name;
            return previousValue;
        }, domains);

        if (Object.keys(domains).length === 1) {
            const [domainId, domainName] = Object.entries(domains)[0];
            onChange({id: parseInt(domainId), name: domainName});
            setValue("");
            setError(null);
        } else if (Object.keys(domains).length === 0) setError(E164ErrorState.NONE_FOUND);
        else if (Object.keys(domains).length > 1) setError(E164ErrorState.AMBIGUOUS);

        setLoading(false);
    };

    return (
        <div style={style}>
            <TextField
                disabled={loading}
                value={value}
                label={<FormattedMessage id="endpointStatus.e164.label" defaultMessage="E.164" />}
                hiddenLabel={false}
                onChange={(ev) => setValue(ev.target.value)}
                margin="dense"
                size="small"
                variant="outlined"
                helperText={error ? <FormattedMessage {...E164_ERROR_MESSAGES[error]} /> : null}
                error={!!error}
                style={{marginTop: 0}}
                onKeyPress={(ev) => {
                    if (ev.charCode === 13 && value.length) search();
                }}
            />
        </div>
    );
};

export default SearchDomainByE164;
